export enum InitiativeStatus {
  New = 'New',
  OnTrack = 'On track',
  AtRisk = 'At risk',
  Done = 'Done',
}

export interface IInitiativeStatus {
  key: InitiativeStatus
  color: string
}

export const STATUS_OPTIONS: IInitiativeStatus[] = [
  { key: InitiativeStatus.New, color: '#5090c0' },
  { key: InitiativeStatus.OnTrack, color: '#d4862a' },
  { key: InitiativeStatus.AtRisk, color: '#c75050' },
  { key: InitiativeStatus.Done, color: '#5ba05a' },
]

export const KEY_INITIATIVE_STATUS_TRANSLATION_PREFIX = 'jbp-key-initiatives-status-'

// Read existing records using the former codes; all editors save the current codes.
const LEGACY_STATUS_CODES = new Map<string, InitiativeStatus>([
  ['work in progress', InitiativeStatus.OnTrack],
  ['needs attention', InitiativeStatus.AtRisk],
])

export const normalizeKeyInitiativeStatus = (status?: string | null): string => {
  const value = status?.trim() ?? ''
  const normalizedValue = value.toLowerCase().replace(/\s+/g, ' ')

  return (
    LEGACY_STATUS_CODES.get(normalizedValue) ??
    STATUS_OPTIONS.find(({ key }) => key.toLowerCase() === normalizedValue)?.key ??
    value
  )
}

export const isKeyInitiativeStatus = (status?: string | null): boolean =>
  STATUS_OPTIONS.some((option) => option.key === normalizeKeyInitiativeStatus(status))

export const getKeyInitiativeStatusTranslationKey = (status?: string | null): string => {
  const value = normalizeKeyInitiativeStatus(status)
  return isKeyInitiativeStatus(value)
    ? `${KEY_INITIATIVE_STATUS_TRANSLATION_PREFIX}${value.toLowerCase().replace(/\s+/g, '-')}`
    : value
}

export const getTranslatedKeyInitiativeStatusOptions = (translate: (key: string) => string) =>
  STATUS_OPTIONS.map((option) => ({
    ...option,
    label: translate(getKeyInitiativeStatusTranslationKey(option.key)),
  }))

export const normalizeKeyInitiativeStatuses = <T extends { Status?: string | null }>(
  records: readonly T[]
): T[] =>
  records.map((record) =>
    record.Status ? { ...record, Status: normalizeKeyInitiativeStatus(record.Status) } : record
  )
